// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1QZjS","open":"style_open__3PN-m","modal":"style_modal__2agqS","head":"style_head__2ms9S","btnClose":"style_btnClose__3rp36","content":"style_content__1j4MX"};